import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/pages/home/components/Navbar";
import Footer from "@/pages/home/components/Footer";
import Lightbox from "@/components/Lightbox";
import { portfolio } from "@/mocks/serra";

export default function Portfolio() {
  const [active, setActive] = useState<number | null>(null);

  return (
    <div className="min-h-screen bg-bg">
      <Navbar />
      <main className="pt-32 pb-24 lg:pb-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-white transition-colors mb-8 cursor-pointer"
          >
            <i className="ri-arrow-left-line"></i>
            Voltar para o início
          </Link>

          <span className="text-cyan text-xs font-mono-tech tracking-[0.2em] uppercase mb-4 block">
            Portfólio Completo
          </span>
          <h1 className="text-white text-3xl lg:text-5xl font-bold mb-14 max-w-2xl">
            Todos os projetos que já colocamos no ar
          </h1>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {portfolio.map((item, index) => (
              <button
                key={item.title}
                onClick={() => setActive(index)}
                className="group relative aspect-square rounded-2xl overflow-hidden cursor-pointer bg-blue/15 text-left"
              >
                <img
                  src={item.image}
                  alt={`${item.title} — ${item.category}`}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-bg/90 via-bg/10 to-transparent opacity-70 group-hover:opacity-90 transition-opacity duration-500"></div>
                <div className="absolute inset-x-0 bottom-0 p-6">
                  <span className="text-xs font-mono-tech uppercase tracking-wider text-cyan mb-1 block">
                    {item.category}
                  </span>
                  <h3 className="text-lg font-semibold text-white">{item.title}</h3>
                </div>
                <span className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center rounded-full bg-bg/70 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <i className="ri-zoom-in-line"></i>
                </span>
              </button>
            ))}
          </div>
        </div>
      </main>
      <Footer />

      {active !== null && (
        <Lightbox
          src={portfolio[active].image}
          alt={portfolio[active].title}
          onClose={() => setActive(null)}
        />
      )}
    </div>
  );
}
